import './badge-list.scss';

/**
 * version    1.0
 * class      <type> (BadgeList)
 * classdesc  Badge List: centered list of badge
 */
export class BadgeList {}
